module.exports = __webpack_public_path__ + "static/media/internship.8169383b.svg";